export default "__VITE_ASSET__DAn_nwmv__"